module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', [_c('v-card', {
    staticClass: "recuperacao-acesso"
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("Recuperação de Acesso\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-conteudo"
  }, [_c('h3', [_vm._v("Selecione a forma de recuperação")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "mandatory": true
    },
    model: {
      value: (_vm.formaRecuperacao),
      callback: function($$v) {
        _vm.formaRecuperacao = $$v
      },
      expression: "formaRecuperacao"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Informar Matrícula/Email",
      "value": "matriculaEmail",
      "color": "orange"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Informar CPF/RG",
      "value": "cpfRg",
      "color": "orange"
    }
  })], 1), _vm._v(" "), (_vm.formaRecuperacao === 'matriculaEmail') ? _c('div', {
    key: "formEmail"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "tel",
      "error-messages": _vm.matriculaErros,
      "label": "Matrícula"
    },
    on: {
      "input": function($event) {
        return _vm.$v.matricula.$touch()
      },
      "blur": function($event) {
        return _vm.$v.matricula.$touch()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enviarRecuperacaoEmail($event)
      }
    },
    model: {
      value: (_vm.matricula),
      callback: function($$v) {
        _vm.matricula = $$v
      },
      expression: "matricula"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.emailErros,
      "label": "Email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enviarRecuperacaoEmail($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.matricula.$invalid || _vm.$v.email.$invalid
    },
    on: {
      "click": _vm.enviarRecuperacaoEmail
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Enviar Email de Recuperação")])]), _vm._v(" "), (_vm.emailDeRecuperacaoEnviado) ? _c('div', {
    staticClass: "email-enviado"
  }, [_vm._v("\n                    Enviamos um email para "), _c('strong', [_vm._v(_vm._s(_vm.emailEnviado))]), _vm._v(",\n                    acesse o link enviado para completar o processo de recuperação.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.emailDeRecuperacaoEnviado) ? _c('div', {
    staticClass: "email-enviado"
  }, [_vm._v("\n                    Caso você não tenha mais acesso a esse email, entre em contato conosco para realizar a alteração\n                    do seu email principal."), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Central de Atendimento")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Telefone:")]), _vm._v(" (53) 3242.8244 - Ramal 1090/1091/1092/1093"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email:")]), _vm._v(" centraldeatendimento@urcamp.edu.br\n                ")]) : _vm._e(), _vm._v(" "), (_vm.emailCadastroNaoEncontrado) ? _c('div', {
    staticClass: "cadastro-naoencontrado"
  }, [_vm._v("\n                    Não conseguimos encontrar o cadastro do email "), _c('strong', [_vm._v(_vm._s(this.email))]), _vm._v(",\n                    verifique o email digitado ou utilize as outras formas de recuperação.\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.formaRecuperacao === 'cpfRg') ? _c('div', {
    key: "formCpfRg"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "type": "tel",
      "error-messages": _vm.cpfErros,
      "label": "CPF"
    },
    on: {
      "input": function($event) {
        return _vm.$v.cpf.$touch()
      },
      "blur": function($event) {
        return _vm.$v.cpf.$touch()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enviarRecuperacaoCpfRg($event)
      }
    },
    model: {
      value: (_vm.cpf),
      callback: function($$v) {
        _vm.cpf = $$v
      },
      expression: "cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.rgErros,
      "label": "Identidade"
    },
    on: {
      "input": function($event) {
        return _vm.$v.rg.$touch()
      },
      "blur": function($event) {
        return _vm.$v.rg.$touch()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enviarRecuperacaoCpfRg($event)
      }
    },
    model: {
      value: (_vm.rg),
      callback: function($$v) {
        _vm.rg = $$v
      },
      expression: "rg"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.cpf.$invalid || _vm.$v.rg.$invalid
    },
    on: {
      "click": _vm.enviarRecuperacaoCpfRg
    }
  }, [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Enviar Email de Recuperação")])]), _vm._v(" "), (_vm.emailDeRecuperacaoEnviado) ? _c('div', {
    staticClass: "email-enviado"
  }, [_vm._v("\n                    Enviamos um email para "), _c('strong', [_vm._v(_vm._s(_vm.emailEnviado))]), _vm._v(",\n                    acesse o link enviado para completar o processo de recuperação.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.cpfRgCadastroNaoEncontrado) ? _c('div', {
    staticClass: "cadastro-naoencontrado"
  }, [_vm._v("\n                    Não conseguimos encontrar o cadastro com "), _c('strong', [_vm._v("CPF ou RG")]), _vm._v(" que foram informados,\n                    verifique os dados digitados ou utilize as outras formas de recuperação.\n                ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "voltar-login"
  }, [_c('v-btn', {
    on: {
      "click": _vm.voltarLogin
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v("Voltar para a tela de login")])])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6eda415e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/login/components/partials/RecuperarSenha.vue
// module id = 556
// module chunks = 2